import AssignManufacturingOrder from './AssignManufacturingOrder';
import CreateManufacturingOrder from './CreateManufacturingOrder';
import CreateProcessInMO from './CreateProcessInMO';
import CustomDetailManufacturingOrder from './CustomDetailManufacturingOrder';
import DetailManufacOrderA from './DetailManufacOrderA';
import DetailManufacOrderB from './DetailManufacOrderB';
import DetailManufacOrderC from './DetailManufacOrderC';
import EditManufacturingOrder from './EditManufacturignOrder';
import HistoryManufacturingOrder from './HistoryManufacturingOrder';
import ManufacturingOrderBom from './ManufacturingOrderBom';
import ManufactoringOrders from './Manufacturingorders';
import ManufacturingPlaning from './ManufacturingPlaning';
import ReportDisplay from './ReportDisplay';
/**
 * @namespace MMS/ManufacturingOrder
 * @description การจัดการคำสั่งผลิตทั้งหมด ตั้งแต่สร้าง แก้ไข รายการ ประวัติและอื่นๆ
 */
export {
  AssignManufacturingOrder,
  CreateManufacturingOrder,
  CreateProcessInMO,
  CustomDetailManufacturingOrder,
  DetailManufacOrderA,
  DetailManufacOrderB,
  DetailManufacOrderC,
  EditManufacturingOrder,
  HistoryManufacturingOrder,
  ManufactoringOrders,
  ManufacturingOrderBom,
  ManufacturingPlaning,
  ReportDisplay,
};

export default {
  AssignManufacturingOrder,
  CreateManufacturingOrder,
  DetailManufacOrderA,
  DetailManufacOrderB,
  HistoryManufacturingOrder,
  ManufactoringOrders,
  CreateProcessInMO,
  ManufacturingOrderBom,
  EditManufacturingOrder,
  DetailManufacOrderC,
  CustomDetailManufacturingOrder,
  ManufacturingPlaning,
  ReportDisplay,
};
